/**
 * Do not edit directly
 * Generated on Fri, 26 Jan 2024 09:10:52 GMT
 */

export const SbLineHeight15 = '15px'
export const SbLineHeight20 = '20px'
export const SbLineHeight25 = '25px'
export const SbLineHeight28 = '28px'
export const SbLineHeight30 = '30px'
export const SbLineHeight35 = '35px'
export const SbLineHeight40 = '40px'
export const SbLineHeight45 = '45px'
export const SbLineHeight48 = '48px'
export const SbLineHeight50 = '50px'
export const SbLineHeight60 = '60px'
